import { Route } from '@angular/router';
import { dashboardIntegrationsChildren } from './dashboard-integrations.routes';
import { mastersChildren } from './masters.routes';
import { reportsChildren } from './reports.routes';
import { transactionSettingsChildren } from './transaction-settings.routes';
import { transactionsChildren } from './transactions.routes';
import { utilitiesChildren } from './utilities.routes';

/**
 * Authenticated layout feature routes (same URL paths as legacy flat `app.routes.ts`).
 * Grouped: dashboards & integrations → masters → transactions → reports → utilities → settings.
 */
export const authenticatedFeatureChildren: Route[] = [
  ...dashboardIntegrationsChildren,
  ...mastersChildren,
  ...transactionsChildren,
  ...reportsChildren,
  ...utilitiesChildren,
  ...transactionSettingsChildren,
];
